import { Link, useLoaderData, useNavigate } from "react-router-dom"
import { Button } from "../components/Button";
import mixpanel from "../services/mixpanel";
import { useEffect } from "react";
import { getUserId } from "../services/helpers";





function renderSubscriptionsList(packages){
	if(packages.length ===0){
		return <h3>No Subscriptions added</h3>;
	}
	return packages.map((plan)=> <>
	<div className="info-tile subscription-tile" key={plan.option_id}>
		<div>
		<div className="primary-info-section">
			<b> {plan.plan_name}</b>
			<p>{plan.duration}</p>
		</div>
		<div className="secondary-info-section">
			<b>{plan.currency} {plan.price}</b>
			<b>Status: <span className="status-span">{plan.is_available === 1 ? "Available" : "UnAvailable"}</span></b>
		</div>
		<div className="action-section col">
			<Link className="red-text" to={`/dashboard/subscriptions/add_subscription`}>Edit/ </Link>
		</div>
		</div>


		<p>{plan.description}</p>
	</div>
	</>);
}

export function Subscriptions(){
	const {plans} = useLoaderData();
	const navigate = useNavigate();
	useEffect(()=>{
		mixpanel.identify(getUserId());
	},[]);

	return (
		<main id="Dashboard">
		<h1>Membership Plans</h1>

		<div className="row" id="page-actions">
			<Link>All Membership plans</Link>
			<Button color="blue" label="Add Subscription" onClick={()=>navigate("add_subscription")} />

		</div>

		{renderSubscriptionsList(plans.plans)}



		</main>
	)
}